import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PropertyManagementFeeSettingModel extends Model {
  @attr('number') cleaningFeePercentage!: number;
  @attr('number') accommodationPercentage!: number;

  @belongsTo('property', {
    async: false,
    inverse: 'propertyManagementFeeSetting',
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'property-management-fee-setting': PropertyManagementFeeSettingModel;
  }
}
